import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { parse, stringify } from '../../utils/UrlUtil';

const OrganisationInvoicesTableHeader = () => {
  const history = useHistory();
  const location = useLocation();
  const params = parse(location.search);

  const DEFAULT_FILTER_STATE = {
    query: '',
    ...params.filter,
  };

  const [filter, setFilter] = useState(DEFAULT_FILTER_STATE);

  /**
   * Get old URL and:
   * - parse query params
   * - merge new param values
   * - stringify query params
   * - push new url
   */
  const onQueryVariableChange = () => {
    // build the filter
    const newFilter = {
      ...params.filter,
      ...filter,
    };

    const search = stringify({
      ...params,
      filter: newFilter,
    });

    // update url with the new search, keep the rest of the values
    history.push({
      ...location,
      search,
    });
  };

  /**
   * Update the filter Query.
   */
  const onChangeQueryText = (event) => {
    const updatedFilter = {
      ...filter,
      query: event.currentTarget.value,
    };

    setFilter(updatedFilter);
  };

  return (
    <div className="p-grid">
      <div className="p-col">
        <div className="p-inputgroup">
          <InputText
            value={filter.query}
            onChange={onChangeQueryText}
            onKeyPress={(event) => {
              if (event.key === 'Enter') {
                onQueryVariableChange();
              }
            }}
          />
          <Button icon="pi pi-search" onClick={onQueryVariableChange} />
        </div>
      </div>
    </div>
  );
};

export default OrganisationInvoicesTableHeader;
